import { ApolloClient, createNetworkInterface } from 'apollo-client';
import { Constants } from './helpers/constants';

const url = 'https://dizzee.umusic.com';
const DIZZEE_LOGIN = 'https://dizzee.umusic.com/service/login?app=swiftDizzee';

const networkInterface = createNetworkInterface({
    uri:`${url}/graphql`,
    opts: {
      credentials: 'include',
      mode: 'cors'
    }
});

networkInterface.use([{
   applyMiddleware(req, next) {
     if (!req.options.headers) {
       req.options.headers = {};
     }
     req.options.headers['Application'] = Constants.APPLICATIONNAME;
     next();
   }
 }]);

 networkInterface.useAfter([{
  applyAfterware({ response }, next) {
      if (response.status === 401) {
          window['angularComponentRef'].zone.run(function() { window['angularComponentRef'].componentFn(); });
          location.assign(DIZZEE_LOGIN);
      }
      next();
  }
}]);

const client = new ApolloClient({
  addTypename: false,
  networkInterface
});


export function provideClients() {
  return {
    default: client
  	// extra: extraClient
  };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/graphql.client.ts